import React from "react";
import { Container } from "react-bootstrap";
import ListView from "../../../components/listView/ListView";
import { couponUsageFilterMeta } from "../../../configs/meta/filterMeta/couponUsageFilterMeta";
import couponUsageListViewMeta from "../../../configs/meta/listViewMeta/couponUsageListViewMeta";

const CouponUsage = () => (
  <React.Fragment>
    <Container fluid className="p-0">
      <ListView
        filters={couponUsageFilterMeta}
        meta={couponUsageListViewMeta()}
        title="Coupon Usage List"
      />
    </Container>
  </React.Fragment>
);

export default CouponUsage;
